import http from '../_http'

const FactsFigures = {
  getFactsFigures: data => http.get('/msvc/v1/factfigures/publicPages', data)
}

export default FactsFigures
